import styled from 'styled-components';
import { Button } from '../../../../../common/components/Button/Button';
import { Paragraph } from '../../../../../common/components/Typography/Paragraph/Paragraph';
import { DisplayCard } from '../../../../../common/components/cards/DisplayCard/DisplayCard';
import { DisplayCardContainer } from '../../../../../common/components/cards/DisplayCard/DisplayCard.styles';
import { HeImgix } from '../../../../../common/components/images/HeImgix';
import { ThemeColours } from '../../../../../common/styles/ThemeColours';
import {
  Breakpoint,
  FontSize,
  FONT_STACK,
  LineHeight,
} from '../../../../../common/styles/constants';

export const AdvertisementIndicator = styled.div`
  ${FONT_STACK}
  background: ${ThemeColours.mono100};
  bottom: 6px;
  color: ${ThemeColours.mono600};
  font-size: ${FontSize.EXTRA_SMALL};
  left: 6px;
  line-height: ${LineHeight.EXTRA_SMALL};
  padding: 2px 6px;
  position: absolute;
`;

export const Card = styled(DisplayCard)`
  border-radius: 4px;
  margin-bottom: 8px;

  ${DisplayCardContainer} {
    padding: 16px;
  }
`;

export const GpTelehealthCardList = styled.ul`
  color: ${ThemeColours.mono600};
  font-size: ${FontSize.SMALL};
  padding-left: 18px;
`;

export const GpTelehealthCardImageContainer = styled.div`
  display: inline-block;
  position: relative;
`;

export const GpTelehealthCardImage = styled(HeImgix)`
  height: 200px;
  object-fit: cover;
  object-position: center;
  width: 100%;

  ${Breakpoint.MEDIUM} {
    height: 100%;
    width: 200px;
  }
`;

export const GpTelehealthCardPrice = styled(Paragraph)`
  align-items: center;
  color: ${ThemeColours.mono600};
  display: flex;
  flex: 1;
  justify-content: flex-end;
  margin-bottom: 0;
  margin-right: 12px;
`;

export const GpTelehealthCardFooter = styled.div`
  display: flex;
  margin-top: 18px;
`;

export const GpTelehealthCardButton = styled(Button)`
  width: auto;
`;
